var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('star-rating',{attrs:{"star-size":25,"read-only":_vm.disabled,"rating":_vm.value,"show-rating":false,"activeColor":"#009688"},on:{"rating-selected":function($event){_vm.$emit('input', $event); _vm.$emit('answered');}}})}
var staticRenderFns = []

export { render, staticRenderFns }